module.exports = __webpack_public_path__ + "img/brlxcj.549c8867.png";